module.exports = __webpack_public_path__ + "img/iotag_login.9bc258ed.png";